import { render, staticRenderFns } from "./categories.view.vue?vue&type=template&id=32c041f3&scoped=true"
import script from "./categories.view.vue?vue&type=script&lang=ts"
export * from "./categories.view.vue?vue&type=script&lang=ts"
import style0 from "./categories.view.vue?vue&type=style&index=0&id=32c041f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c041f3",
  null
  
)

export default component.exports